import { useJourneyStore } from "../game/state/journeyMachine";
import { useReducedMotionSync } from "../accessibility/ReducedMotion";
import { useFontScaleSync } from "../accessibility/FontScale";
import { useKeyboardNav } from "../accessibility/KeyboardNav";
import { SimBanner } from "../components/SimBanner";
import { TopBar } from "../components/TopBar";
import { HelpOverlay } from "../components/HelpOverlay";
import { SourcesPanel } from "../components/SourcesPanel";
import { HomeScreen } from "./HomeScreen";
import { JourneyScreen } from "./JourneyScreen";

/**
 * Router por estado (sin react-router): portada ↔ recorrido según la FSM.
 */
export default function App() {
  const screen = useJourneyStore((s) => s.screen);
  useReducedMotionSync();
  useFontScaleSync();
  useKeyboardNav();

  return (
    <>
      <SimBanner />
      <TopBar />
      {screen === "portada" ? <HomeScreen /> : <JourneyScreen />}
      <HelpOverlay />
      <SourcesPanel />
    </>
  );
}
